import { render, staticRenderFns } from "./ReSubMenu.vue?vue&type=template&id=22f94569&scoped=true"
import script from "./ReSubMenu.vue?vue&type=script&lang=js"
export * from "./ReSubMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f94569",
  null
  
)

export default component.exports